import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';
import { semanticTokens } from '@packages/config/theme';
import { Page, PageHeader, PageContent } from '@supabank/ui';
import { Calculator } from 'lucide-react';
import { lazy, Suspense } from 'react';

// Lazy load UnifiedCalculator to reduce initial bundle
const UnifiedCalculator = lazy(() => import("@/components/FeeCalculator/UnifiedCalculator").then(m => ({ default: m.UnifiedCalculator })));

export const DashboardCalculator = () => {
  return (
    <Page data-ux-contract="canon">
      <PageHeader
        icon={Calculator}
        title="Transaction Calculator"
        subtitle="Calculate exact amounts needed for your crypto-to-fiat conversions"
      />

      <PageContent>
        <div className="space-y-6">
          <Suspense fallback={<Skeleton className="h-96 w-full rounded-lg" />}>
            <UnifiedCalculator />
          </Suspense>

          <div className={cn("mt-8 p-4 rounded-lg", semanticTokens.bg.muted, semanticTokens.spacing.md.replace('p-', 'p-'), semanticTokens.radius.lg)}>
            <h3 className={cn(semanticTokens.typography.label, "mb-2")}>How it works</h3>
            <div className={cn("space-y-2", semanticTokens.typography.caption, semanticTokens.fg.muted)}>
              <p>• Enter the fiat amount you want to receive in your bank account</p>
              <p>• Select the crypto asset and network you want to send from</p>
              <p>• The calculator shows exactly how much crypto to send (including all fees)</p>
              <p>• All calculations include the 2% developer fee and Bridge API requirements</p>
            </div>
          </div>
        </div>
      </PageContent>
    </Page>
  );
};